import {defineMessages} from 'react-intl';

export default defineMessages({
	readMore: {
		id: 'productAccordion.productReadMore',
		defaultMessage: '... Read More',
	},
});
